// import header_toggleIsCompact from "../../../toggle-button/function/toggle-is-compact"

import {ProjectSystemType} from "../../../../../../../../core/model2/project/types"

// const debug = "addView_checkConvertRequirementAndConfirm"
const debug = false

export default function addView_checkConvertRequirementAndConfirm(projectId : ID): Promise<'continue' | 'convert' | 'stop'> {
    return new Promise((resolve, reject) => {
        const project = gd.session.projects.get(projectId)!
        const showWarning = project.isPage || project.isEmbed

        debug && console.log(debug, 'process', showWarning)

        if (!showWarning) {
            resolve('continue')
            return
        }

        toggleAllPopovers(true)

        let title = ''
        let message = ''

        switch (project.systemType) {
            case ProjectSystemType.PAGE:
                title   = 'Convert page'
                message = 'You are trying to add a view to Page. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert Page into Folder? ' +
                    'This action cannot be reverted.'
                break

            case ProjectSystemType.EMBED:
                title   = 'Convert embed'
                message = 'You are trying to add a view to Embed structure element. ' +
                    'It should be converted to Folder before new view is added. ' +
                    'Are you sure you want to convert Embed structure element into Folder? ' +
                    'This action cannot be reverted.'
                break
        }

        gd.modals.confirm.genericText(title,message, async () => {
            gd.modal.hide()
            toggleAllPopovers(false)
            resolve('convert')

            await gd.api.Project.convertToFolder(projectId, {}).promise()
            gd.bus.triggerEvent('toggle-submenu')
            // header_toggleIsCompact(projectId)
        }, {
            yesBtnLabel : 'Yes, proceed',
            onNoCallback: () => {
                toggleAllPopovers(false)
                resolve('stop')
            }
        })
    })
}

function toggleAllPopovers(value: boolean) {
    _.map(document.querySelectorAll('.popover'), node=>{
        debug && console.log(debug, 'toggleAllPopovers', node.childNodes[0], node)

        gd.utils.Dom.toggleClass(node.childNodes[0], "is-hidden", value)
    })
}